export default {
  qa_typo_grammar_format: {
    caption:
      'The question and/or answers have typos, grammar or format issues.',
    order: 0
  },
  qa_ambiguous: {
    caption: 'The question is ambiguous or misleading.',
    order: 1
  },
  qa_no_correct_ans: { caption: 'None of the answers is correct.' },
  order: 2,
  qa_two_correct_ans: {
    caption: 'More than one of the answers are correct.',
    order: 3
  },
  qa_other_ans: { caption: 'There are other possible answers.', order: 4 },
  qa_incorrect_others: {
    caption: 'Other issue making q/a incorrect.',
    order: 5
  },
  qa_others: { caption: 'Other q/a issues.', order: 6 },
  s_typo_grammar_format: {
    caption: 'The solution has typos, grammar or format issues.',
    order: 7
  },
  s_no_answer: {
    caption: 'The solution is not answering the question.',
    order: 8
  },
  s_no_conclusion: {
    caption: "The solution doesn't give a conclusion.",
    order: 9
  },
  s_incorrect: { caption: 'The solution is wrong.', order: 10 },
  s_others: { caption: 'Other solution issues.', order: 11 }
}
